import { render } from "./RecMenu.vue?vue&type=template&id=068f1dcd&scoped=true"
import script from "./RecMenu.vue?vue&type=script&lang=js"
export * from "./RecMenu.vue?vue&type=script&lang=js"

import "./RecMenu.vue?vue&type=style&index=0&id=068f1dcd&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/todaymeal_front/todaymeal_front/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-068f1dcd"]])

export default __exports__